import React from "react";
import { useAuth } from "../../context/AuthContext";
import RepDashboard from "./RepDashboard";
import ManagerDashboard from "./ManagerDashboard";
import CompanyAdminDashboard from "./CompanyAdminDashboard";
import ReppiAdminDashboard from "./ReppiAdminDashboard";

function DashboardPage() {
  const { user } = useAuth();

  switch (user?.role) {
    case "REP":
      return <RepDashboard />;
    case "MANAGER":
      return <ManagerDashboard />;
    case "COMPANY_ADMIN":
      return <CompanyAdminDashboard />;
    case "REPPI_ADMIN":
      return <ReppiAdminDashboard />;
    default:
      return <RepDashboard />;
  }
}

export default DashboardPage;
